import axios from 'axios';

export const createOrg = (data) => async (dispatch) => {
  return axios
    .post('/api/admin/neworg', data)
    .then((res) => {
      if (!res.data.success) {
        throw new Error();
      }
    })
    .catch((err) => {
      throw err.response.data.errors;
    });
};
